<script lang="ts" setup>
import type { Link } from "@/modules/public/components/HomeNavigationLink";
import { mdiChevronDown, mdiChevronRight } from "@mdi/js";
import { useTranslate } from "@/composables/use-translate";

const { t } = useTranslate();

const items: { header: string; links: Link[] }[] = [
  {
    header: "Over het programma",
    links: [
      {
        name: `Op school, thuis en bij ${t("rt")}`,
        to: "school-rt-thuis",
      },
      {
        name: "Het adaptieve programma",
        to: "adaptief",
      },
      {
        name: "Aangepast oefenen",
        to: "aangepast-oefenen",
      },
      {
        name: "Voortgang volgen",
        to: "voortgang-volgen",
      },
      {
        name: "Beloningssysteem",
        to: "beloningssysteem",
      },
      {
        name: "Spellen",
        to: "spellen",
      },
    ],
  },
  {
    header: "Achtergrond",
    links: [
      {
        name: "De didactiek",
        to: "didactiek",
      },
      {
        name: "Breed inzetbaar",
        to: "inzetbaarheid",
      },
      {
        name: "Web-based",
        to: "web-based",
      },
      {
        name: "Wetenschappelijk onderbouwde werkzame componenten",
        to: "werkzame-componenten",
      },
      {
        name: "Wat is nodig om goed te leren spellen? - Tom Braams",
        to: "watisnodigvoorspellen",
      },
    ],
  },
  {
    header: "Ervaringen",
    links: [
      {
        name: "Leerkrachten over Taalblobs",
        to: "ervaringen",
      },
    ],
  },
];
</script>

<template>
  <li>
    <v-menu
      location="bottom"
      :open-on-hover="$vuetify.display.mdAndUp"
      open-on-click
    >
      <template v-slot:activator="{ props }">
        <v-btn
          :class="
            items
              .flatMap((item) => item.links)
              ?.some(({ to }) => $route.name === to)
              ? 'bg-grey-lighten-2'
              : ''
          "
          v-bind="props"
          :block="$vuetify.display.mdAndDown"
          class="font-weight-medium mr-1"
          variant="plain"
        >
          Over Taalblobs <v-icon class="ml-1">{{ mdiChevronDown }}</v-icon>
        </v-btn>
      </template>

      <div class="d-flex elevation-4 rounded-lg overflow-hidden">
        <v-list
          nav
          density="compact"
          color="primary"
          v-for="(item, i1) in items"
          :key="i1"
          style="max-width: 15rem"
        >
          <h4 class="px-2 py-2">{{ item.header }}</h4>
          <v-divider class="mb-2" />
          <v-list-item
            class="py-0"
            v-for="(link, i) of item.links"
            :key="i"
            :to="{ name: link.to }"
          >
            <v-list-item-title class="px-2 text-wrap d-flex">
              <v-icon class="mr-2">{{ mdiChevronRight }}</v-icon>
              <p style="padding-top: 2px">
                {{ link.name }}
              </p></v-list-item-title
            >
          </v-list-item>
        </v-list>
      </div>
    </v-menu>
  </li>
</template>
